import React, { Component } from "react";
import { connect } from "react-redux";
import history from "../../../Utils/History";
import {
  getPlanDetails,
  setStateParams,
  setFormData,
} from "../../../Redux/Actions/webAppActions";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import { Text } from "react-internationalization";
import { LANG } from "../../translations/dynamic";

class PlanCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comparePlans: this.props.comparePlans,
      snackBarOpen: false,
      snackBarMsg: "",
      vertical: "top",
      horizontal: "center",
      snackBarSeverty: "",
    };
  }

  fetchPlanDetails = async (
    e,
    planId,
    planType,
    productId,
    premiumAmount,
    planName,
    productCategory
  ) => {
    e.preventDefault();
    window.sessionStorage.setItem(
      "cmpnames",
      JSON.stringify([
        {
          planId: planId,
          productId: productId,
          monthlyPremium: premiumAmount,
          planName: planName,
        },
      ])
    );
    //planid="1"
    let body = { customerId: this.props?.customerId };
    let formPayload = {
      planId: planId,
      productId: productId,
      premiumAmount: premiumAmount,
      planName: planName,
      productCategory: productCategory ? productCategory : "",
    };
    this.props.setFormData(formPayload);
    console.log("this.props.year", this.props.year);
    await this.props.setStateParams("detailsPlanType", planType.toLowerCase());
    await this.props.getPlanDetails(
      body.customerId,
      productId,
      this.props.year
    );
    await this.props.setStateParams("selectedPlansForCompare", [productId]);
    history.push("/e-Enroll/compare-plan");
  };

  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({
      snackBarOpen: false,
    });
  };

  render() {
    const { cardData, handleCheckedPlan } = this.props;
    const { snackBarOpen, snackBarMsg, vertical, horizontal, snackBarSeverty } =
      this.state;
    const planName = cardData.planName;
    const planNameES = cardData.planNameES;

    return (
      <>
        <Snackbar
          open={snackBarOpen}
          autoHideDuration={3000}
          onClose={this.handleClose}
          anchorOrigin={{ vertical, horizontal }}
          key={vertical + horizontal}
        >
          <Alert onClose={this.handleClose} severity={snackBarSeverty}>
            {snackBarMsg}
          </Alert>
        </Snackbar>
        <div
          className={`plan-container ${this.props.planIndex > 0 ? "mt-4" : ""}`}
        >
          <div className="plan-head">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12 col-md-9 col-lg-10 px-0">
                  <div className="plan-heading">
                    <h4 id="Plan1">
                      {this.props.lang === "es"
                        ? planNameES?.toUpperCase()
                        : planName?.toUpperCase()}
                    </h4>
                  </div>
                </div>
                {cardData.count > 1 && (
                  <div className="col-12 col-md-3 col-lg-2 text-end">
                    <div className="plan-compare-checkbox">
                      <label
                        className="form-check-label text-white ms-2"
                        htmlFor="compare1"
                      >
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="checkbox"
                          id="compare1"
                          className="form-check-input compare-checkbox"
                          checked={
                            this.props.comparePlans.indexOf(
                              cardData.productId
                            ) !== -1
                          }
                          onChange={handleCheckedPlan}
                          value={cardData.productId}
                          disabled={
                            this.props.disablePlan === true &&
                            this.props.comparePlans.indexOf(
                              cardData.productId
                            ) === -1
                              ? true
                              : false
                          }
                        />{" "}
                        <span onClick={(event) => event.preventDefault()}>
                          <Text id="app.compare" />
                        </span>
                      </label>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="plan-body">
            <div className="container">
              <div className="row pt-4 pb-4">
                <div className="col-12 col-md-5">
                  <div className="row">
                    <div className="col-12 col-lg-5 text-center pt-lg-0 pb-lg-0 pb-3 pt-1">
                      <p className="plan-premium">
                        {cardData.monthlyPremium.includes("$")
                          ? cardData.monthlyPremium
                          : "$" + cardData.monthlyPremium}
                      </p>
                      <p className="bold">
                        <Text id="plan.monthlyp" />
                      </p>
                      <button
                        className="btn-shp btn-shp-default"
                        id="btn_select"
                        value={planName}
                        onClick={(e) =>
                          this.props.handleSelect(
                            e,
                            cardData.planId,
                            this.props.lang === "es"
                              ? cardData.planNameES?.toUpperCase()
                              : cardData.planName?.toUpperCase(),
                            cardData.productName,
                            cardData.productId,
                            cardData.monthlyPremium,
                            cardData?.productCategory,
                            cardData?.pbpId
                          )
                        }
                      >
                        <Text id="header.enroll" />
                      </button>
                    </div>
                    <div className="col-12 col-lg-7 pt-lg-0 pb-lg-0 pb-3 pt-3">
                      <p>
                        <Text id="sharp.planCommanTitle" />
                      </p>
                      <a
                        href="none"
                        onClick={(e) =>
                          this.fetchPlanDetails(
                            e,
                            cardData.planId,
                            cardData.productName,
                            cardData.productId,
                            cardData.monthlyPremium,
                            this.props.lang === "es"
                              ? cardData.planNameES?.toUpperCase()
                              : cardData.planName?.toUpperCase(),
                            cardData?.productCategory
                          )
                        }
                      >
                        <Text id="sharp.planDetails" />{" "}
                        <i className="icon icon-right" />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-1 border-middle" />
                <div className="col-12 col-md-6">
                  <div className="row">
                    <div className="col-12 col-lg-5">
                      <p className="bold">
                        <Text id="sharp.costShare" />
                      </p>
                      <ul className="list-type1 row-flex">
                        <li>
                          <div>
                            <Text id="app.plantype" />
                          </div>
                          <div>{cardData.planType}</div>
                        </li>
                        {cardData?.pcpCopay && cardData.pcpCopay != null && (
                          <li>
                            <div>
                              <Text id="plan.PCPcopay" />
                            </div>
                            <div>
                              {cardData.pcpCopay.indexOf("$") > -1
                                ? cardData.pcpCopay
                                : "$" + cardData.pcpCopay}
                            </div>
                          </li>
                        )}
                        {cardData?.specialistCopay &&
                          cardData.specialistCopay != null && (
                            <li>
                              <div>
                                <Text id="plan.scopay" />
                              </div>
                              <div>
                                {cardData.specialistCopay.indexOf("$") > -1
                                  ? cardData.specialistCopay
                                  : "$" + cardData.specialistCopay}
                              </div>
                            </li>
                          )}
                        {cardData?.preferredGeneric &&
                          cardData.preferredGeneric != null && (
                            <li>
                              <div>
                                {" "}
                                <Text id="plan.preferredg" />
                              </div>
                              <div>
                                {cardData.preferredGeneric.indexOf("$") > -1
                                  ? cardData.preferredGeneric
                                  : "$" + cardData.preferredGeneric}
                              </div>
                            </li>
                          )}
                        {cardData?.preferredBrand &&
                          cardData.preferredBrand != null && (
                            <li>
                              <div>
                                {" "}
                                <Text id="plan.preferredb" />
                              </div>
                              <div>
                                {" "}
                                {cardData.preferredBrand.indexOf("$") > -1
                                  ? cardData.preferredBrand
                                  : "$" + cardData.preferredBrand}
                              </div>
                            </li>
                          )}
                        {cardData?.partADeductible &&
                          cardData.partADeductible != null && (
                            <li>
                              <div>
                                <Text id="plan.partAd" />
                              </div>
                              <div>
                                {cardData.partADeductible.indexOf("$") > -1
                                  ? cardData.partADeductible
                                  : "$" + cardData.partADeductible}
                              </div>
                            </li>
                          )}
                        {cardData?.partBDeductible &&
                          cardData.partBDeductible != null && (
                            <li>
                              <div>
                                <Text id="plan.partAd" />
                              </div>
                              <div>
                                {cardData.partBDeductible.indexOf("$") > -1
                                  ? cardData.partBDeductible
                                  : "$" + cardData.partBDeductible}
                              </div>
                            </li>
                          )}
                        {cardData?.partDDeductible &&
                          cardData.partDDeductible != null && (
                            <li>
                              <div>
                                <Text id="plan.partAd" />
                              </div>
                              <div>
                                {cardData.partDDeductible.indexOf("$") > -1
                                  ? cardData.partDDeductible
                                  : "$" + cardData.partDDeductible}
                              </div>
                            </li>
                          )}
                      </ul>
                    </div>
                    <div className="col-12 col-lg-7 plancardbenefitsLeft">
                      <p className="bold">
                        <Text id="sharp.incBenefit" />
                      </p>
                      <ul className="list-type1 green-bullet">
                        {cardData?.includedBenefits.map((benefit, index) => (
                          <li key={cardData?.includedBenefits[index]}>
                            {this.props.lang === "es" &&
                            LANG.INCLUDED_BENEFITS[benefit]
                              ? LANG.INCLUDED_BENEFITS[benefit]
                              : benefit}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              {cardData?.productCategory === "RETIREE" && (
                <p>
                  <Text id="sharp.retireenote" />
                </p>
              )}
              {cardData?.productCategory === "GROUP" && (
                <p>
                  <Text id="sharp.grpnote" />
                </p>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    year: state.webApp.year?.planYear
      ? state.webApp.year.planYear
      : state.webApp.year,
    email: state.login.emailAddress,
    guestLoggedIn: state.login.guestLogin,
    zipCode: state.webApp.zip,
    agentLogin: state.login.agentLoggedIn,
    countyName: state.webApp.county?.countyName
      ? state.webApp.county?.countyName
      : state.webApp.county,
    stateCd: state.webApp.stateCd,
    CountyCd: state.webApp.CountyCd,
    agentemail: state.login.agentEmailId,
    customerId: state.login.customerId,
    lang: state.webApp.language,
    deeplink: state.login.deeplink,
    dpcountyName: state.login.dpcountyName,
    dpzipCode: state.login.dpzipCode,
    dpProductId: state.login.dpProductId,
    dpStateCd: state.login.dpStateCd,
    dpemail: state.login.dpemail,
    theme: state.login.theme,
  };
};
const mapDispatchToProps = {
  getPlanDetails,
  setStateParams,
  setFormData,
};

export default connect(mapStateToProps, mapDispatchToProps)(PlanCard);
